import { isEmpty } from 'lodash/fp';
import { Defaults } from 'app/lib/constants';
import * as styles from './FieldWarning.css';

export interface FieldWarningProps {
    messages?: string | string[];
}

export function FieldWarning({ messages = Defaults.ARRAY }: FieldWarningProps) {
    if (isEmpty(messages)) {
        return null;
    }

    return <span className={styles.base}>{messages}</span>;
}
